import { render, staticRenderFns } from "./DraftActions.vue?vue&type=template&id=4b121ea7&scoped=true"
import script from "./DraftActions.vue?vue&type=script&lang=js"
export * from "./DraftActions.vue?vue&type=script&lang=js"
import style0 from "./DraftActions.vue?vue&type=style&index=0&id=4b121ea7&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b121ea7",
  null
  
)

export default component.exports